import Vue from 'vue'
import Router from 'vue-router'
import App from '../App'
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'main',
      component: App,
      redirect: '/index'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@v/Login')
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@v/index')
    },
    {
      path: '/dataMonitor',
      name: 'dataMonitor',
      component: () => import('@v/DataMonitoring/dataMonitoring')
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('@v/Map/map')
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && to.path !== '/index' && !sessionStorage.getItem('token')) {
    next({
      path: 'login'
    })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js